import { render, staticRenderFns } from "./repairItem.vue?vue&type=template&id=6ff184d6&scoped=true&"
import script from "./repairItem.vue?vue&type=script&lang=js&"
export * from "./repairItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff184d6",
  null
  
)

export default component.exports